import { useState } from 'preact/hooks';
import { FilePickerOpts } from '@components/filepicker';
import {
  ManagedFile,
  MediaManager,
  PickFooter,
  UploadButton,
  useMediaManagerUpload,
  usePickSelection,
} from '@components/media-manager';
import { FolderFilter } from '@components/media-manager/state';

type Props = {
  accept?: string;
  uploadOpts?: FilePickerOpts;
  multiSelect?: boolean;
  enableFolders?: boolean;
  onPick(files: ManagedFile[]): void;
  onCancel(): void;
};

export function LibraryView({
  accept,
  uploadOpts,
  multiSelect,
  enableFolders = true,
  onPick,
  onCancel,
}: Props) {
  const [folderId, setFolderId] = useState<FolderFilter>('root');
  const selection = usePickSelection(onPick, multiSelect);
  const upload = useMediaManagerUpload({
    mode: 'pick',
    accept,
    uploadOpts,
    multiUpload: multiSelect,
    folderId,
    onPick: selection.onUploaded,
  });

  return (
    <>
      <div class="flex-1 min-h-0 overflow-auto px-3 py-4 sm:px-6">
        <MediaManager
          mode="pick"
          accept={accept}
          onPick={onPick}
          refreshSignal={upload.refreshSignal}
          enableFolders={enableFolders}
          onFolderChange={setFolderId}
          picked={selection.picked}
          onTogglePick={selection.togglePick}
          headerActions={
            <UploadButton onClick={() => upload.upload()} isLoading={upload.isUploading} />
          }
        />
      </div>
      {multiSelect && <PickFooter selection={selection} onCancel={onCancel} />}
    </>
  );
}
